import NotificationService from "../services/customer/NotificationService";
import { 
    PUSH_NOTIFICATION, 
    POP_NOTIFICATION,
    UPDATE_NOTIFICATION_VISIBILITY, 
    UPDATE_NOTIFICATIONS_COUNT 
} from "./actions"

export default {
    state: {
        notifications: [],
        notificationSequence: 1,
        notificationsCount: 0,
    },
    getters: {
        notifications: state => state.notifications,
        notificationsCount: state => state.notificationsCount,

    },

    mutations: {
        [PUSH_NOTIFICATION]: (state, notification) => {
            notification.id = state.notificationSequence++;
            state.notifications.unshift(notification);
        },
        [POP_NOTIFICATION]: (state, notification) => {
            state.notifications = state.notifications.filter((not) => { return not.id !== notification.id })
        },
        [UPDATE_NOTIFICATION_VISIBILITY]: (state, index) => {

            if (state.notifications[index])
                state.notifications[index].toBeRemoved = false;
        },

        [UPDATE_NOTIFICATIONS_COUNT]: (state, notificationsCount) => {
            state.notificationsCount = notificationsCount;
        }

    },
    
    actions: {
        [PUSH_NOTIFICATION]: ({ commit }, notification) => {

            notification.toBeRemoved = true;
            commit(PUSH_NOTIFICATION, notification);
            let interval = setInterval(() => {
                if (notification.toBeRemoved) {
                    commit(POP_NOTIFICATION, notification)
                    clearInterval(interval)
                } else {
                    notification.toBeRemoved = true
                }
            }, 6000)
        },
        [POP_NOTIFICATION]: ({ commit }, notification) => {

            commit(POP_NOTIFICATION, notification);
        },
        [UPDATE_NOTIFICATION_VISIBILITY]: ({ commit }, index) => {
            commit(UPDATE_NOTIFICATION_VISIBILITY, index)
        },

        [UPDATE_NOTIFICATIONS_COUNT]: async(context) => {
           var notificationService = new NotificationService();
           var result = await notificationService.count();
           context.commit(UPDATE_NOTIFICATIONS_COUNT, result.data.data);
           return result.data.data
        },

    },
   
};